module.exports = __webpack_public_path__ + "84f8192c00e8f96ef18f6b430256c479.svg";